Ext.define('SA.TableTopSection', {
    extend: 'SA.TableSection',

    setData(data) {
        data.forEach((cellData, columnIndex) => {
            var el = this.table.getCellAt({rowIndex: 0, columnIndex});

            this.cellsCache.setState(el, cellData);
        });
    },

    setScrollerSizeForContainerSize({containerSize}) {
        var width = containerSize.width,
            height = containerSize.height + Ext.getScrollbarSize().height;

        this.scroller.setSize({width, height});
    }
});